export default "__VITE_ASSET__49a8bc79__"